import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs';
import { UserService } from '../../services/user.service';
import { CAUserDto } from 'src/core/models/administration/user/CAUser.dto';
import { AutoUnsubscribe } from 'src/core/decorators/auto-unsubscribe.decorator';
import { BaseDropdownSelectorComponent } from 'src/ui/base-selector/base-selector.module';
import { FileUploadService } from 'src/core/services/fileupload/fileupload.service';

@Component({
  selector: 'ca-user-dropdown-selector',
  templateUrl: './user-dropdown-selector.component.html',
  styleUrls: ['./user-dropdown-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => UserDropdownSelectorComponent),
    },
  ],
  standalone: false,
})
@AutoUnsubscribe()
export class UserDropdownSelectorComponent
  extends BaseDropdownSelectorComponent<CAUserDto>
  implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor
{
  @Input()
  userType: 'all' | 'agent' | 'evaluator' = 'all';

  @Input()
  dropdownPosition: 'auto' | 'top' | 'bottom' = 'auto';

  @Input()
  enabledUserStatusFilter: boolean = true;

  userStatusFilter: 'all' | 'active' | 'passive' = 'active';

  userPhotoComponentStyles: any = {
    width: '100%',
    height: '100%',
    'border-radius': '50%',
  };

  private _userProfileThumbnailsCached: boolean = false;

  get userProfileThumbnailsCached(): boolean {
    return this._userProfileThumbnailsCached;
  }

  constructor(
    protected elementRef: ElementRef,
    protected ngZone: NgZone,
    private service: UserService,
    private fileUploadService: FileUploadService,
  ) {
    super(elementRef, ngZone);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.quickSearchTermInput$
      .pipe(takeUntil(this.autoUnsubscribeNotifier), debounceTime(250), distinctUntilChanged())
      .subscribe(val => {
        this.pageIndex = 0;
        this.quickSearchTerm = val;

        this.load();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onUserStatusFilterChanged(eventArgs: Event): void {
    const radio = eventArgs.currentTarget as HTMLInputElement;

    if (radio.checked && radio.value) {
      this.userStatusFilter = radio.value as 'all' | 'active' | 'passive';
      this.pageIndex = 0;
      this.load();
    }
  }

  compareFn(a: CAUserDto, b: CAUserDto): boolean {
    return a.id === b.id;
  }

  protected load(): void {
    this.loading = true;
    this._userProfileThumbnailsCached = false;

    var filters = this.service.getFilter(
      this.quickSearchTerm,
      this.userType,
      this.userStatusFilter,
      null,
    );

    this.service
      .getList(filters, this.pageIndex, this.itemsPerPage, true)
      .pipe(take(1))
      .subscribe(response => {
        this.totalCount = response.totalCount;
        this.items = response.items;

        this.loading = false;

        if (this.items.length > 0) {
          var userIds = this.items.map(u => u.id);
          this.fileUploadService.bulkDownloadProfileThumbnail(userIds, filters).subscribe(() => {
            this._userProfileThumbnailsCached = true;
          });
        }
      });
  }
}
